<template>
  <div>
      <v-footer app inset><span>{{ $t('lbl.footer_text')}} - v 2.0.5</span></v-footer>
  </div>
</template>
<script>
module.exports = {
  
};
</script>